// Add your JS customizations here
import Dropdown from 'bootstrap/js/dist/dropdown';
import Tooltip from 'bootstrap/js/dist/tooltip';

(function () {
    var navbarToggle = document.getElementById('navbarNavDropdown');

    if (navbarToggle) {
        navbarToggle.addEventListener('shown.bs.collapse', function (event) {
            var navigationDropdowns = new Dropdown('.nav-link[data-bs-toggle="dropdown"]').show();
        });

        navbarToggle.addEventListener('show.bs.collapse', function (event) {
            document.body.classList.add('mobile-menu-open');
        });

        navbarToggle.addEventListener('hidden.bs.collapse', function (event) {
            document.body.classList.remove('mobile-menu-open');
        });
    }

    /*
    *   Initialize Tooltips
    */
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    if (tooltipTriggerList) {
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl)
        });
    }

    /*
    *   Modal Bonus
    */
    var bonusModal = document.getElementById('bonusModal');
    var bonusModalLoaded = false;
    if (bonusModal) {
        bonusModal.addEventListener('show.bs.modal', function (event) {
            if (bonusModalLoaded == false) {
                // Load the content via AJAX when the modal is triggered.
                const xhr = new XMLHttpRequest();
                xhr.open("POST", ajaxurl, true);
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        // Populate the modal with the content received from the server.
                        const modalContent = document.querySelector(".modal-body");
                        if (modalContent) {
                            modalContent.innerHTML = xhr.responseText;
                        }
                    }
                };
                xhr.send("action=load_modal_bonus_content");

                bonusModalLoaded = true;
            }
        });
    }

    /*
    * Replace all SVG images with inline SVG
    */
    fixSvgs();

    /*
    * Replace all | in breadcrumbs
    */
    document.querySelectorAll('.breadcrumbs-item span').forEach(function (element) {
        var string = element.innerHTML;
        var modifiedString = string.replace(' |', '');
        element.innerHTML = modifiedString;
    });

    /*
    * Trigger position sticky
    */
    var element = document.getElementById('bonusStickyTop');
    if (typeof (element) != 'undefined' && element != null) {
        var startProductBarPos = -1;
        window.onscroll = function () {
            var stickyElm = document.getElementById('bonusStickyTop');
            if (startProductBarPos < 0) startProductBarPos = findPosY(stickyElm);

            if (pageYOffset > startProductBarPos) {
                stickyElm.classList.add('is-sticky');
            } else {
                stickyElm.classList.remove('is-sticky');
            }

        };

        function findPosY(obj) {
            var curtop = 0;
            if (typeof (obj.offsetParent) != 'undefined' && obj.offsetParent) {
                while (obj.offsetParent) {
                    curtop += obj.offsetTop;
                    obj = obj.offsetParent;
                }
                curtop += obj.offsetTop;
            }
            else if (obj.y)
                curtop += obj.y;
            return curtop;
        }
    }

    // Init Table of contents
    var tocElement = document.getElementById('toc');
    if (typeof (tocElement) != 'undefined' && tocElement != null) {
        makeList({
            'target': '#toc',   // Selector for element to place table of contents
            'parent': '.main-content-body' // Selector for element to parse headers from (default: 'body')
        });

        // Remove ToC if there are no headings in article
        var tocList = document.querySelectorAll('#toc ul li');
        if (tocList.length == 0) {
            console.log('Table Of Contents: Generation Not Possible.')
            var element = document.getElementById("accordion-container");
            element.remove();
        }
    }

    // CF7 Form Manipulation
    var wpcf7Elm = document.querySelector('.wpcf7');
    if (typeof wpcf7Elm != 'undefined' && wpcf7Elm != null) {
        wpcf7Elm.addEventListener('wpcf7submit', function (event) {
            setTimeout(function () {
                document.querySelectorAll('.wpcf7-form-control').forEach(function (input) {
                    var parent = input.parentElement.parentElement;
                    if (input.classList.contains('wpcf7-not-valid')) {
                        parent.classList.add('not-valid');
                    } else {
                        parent.classList.remove('not-valid');
                    }
                });
            }, 10);
        }, false);

        /* Validation Events for changing response CSS classes */
        document.addEventListener('wpcf7invalid', function (event) {
            document.querySelectorAll('.wpcf7-response-output').forEach(function (notification) {
                notification.classList.remove('notification-error');
                notification.classList.remove('notification-alert');
                notification.classList.remove('notification-success');
                notification.classList.add('notification');
                notification.classList.add('notification-error');
            });
        }, false);
        document.addEventListener('wpcf7spam', function (event) {
            document.querySelectorAll('.wpcf7-response-output').forEach(function (notification) {
                notification.classList.remove('notification-error');
                notification.classList.remove('notification-alert');
                notification.classList.remove('notification-success');
                notification.classList.add('notification');
                notification.classList.add('notification-alert');
            });
        }, false);
        document.addEventListener('wpcf7mailfailed', function (event) {
            document.querySelectorAll('.wpcf7-response-output').forEach(function (notification) {
                notification.classList.remove('notification-error');
                notification.classList.remove('notification-alert');
                notification.classList.remove('notification-success');
                notification.classList.add('notification');
                notification.classList.add('notification-alert');
            });
        }, false);
        document.addEventListener('wpcf7mailsent', function (event) {
            document.querySelectorAll('.wpcf7-response-output').forEach(function (notification) {
                notification.classList.remove('notification-error');
                notification.classList.remove('notification-alert');
                notification.classList.remove('notification-success');
                notification.classList.add('notification');
                notification.classList.add('notification-success');
            });
        }, false);
    }

    // FAQ Accordion Toggler
    var rankMathQuestions = document.querySelectorAll('.rank-math-question');

    if (typeof rankMathQuestions != 'undefined' && rankMathQuestions != null) {
        for (var i = 0; i < rankMathQuestions.length; i++) {
            rankMathQuestions[i].addEventListener('click', function (event) {
                parent = this.parentElement;
                if (parent.classList.contains('open')) {
                    parent.classList.remove('open');
                } else {
                    parent.classList.add('open');
                }
            });
        }
    }

    // Show More & Show Less
    var showMoreTriggers = document.querySelectorAll('.show-more-trigger');
    var showLessTriggers = document.querySelectorAll('.show-less-trigger');

    if (typeof showMoreTriggers != 'undefined' && showMoreTriggers != null) {

        for (var i = 0; i < showMoreTriggers.length; i++) {
            showMoreTriggers[i].addEventListener('click', function (event) {
                parent = this.parentElement.parentElement;

                if (parent.classList.contains('list-cropped')) {
                    parent.classList.remove('list-cropped');
                }
            });
        }
    }

    if (typeof showLessTriggers != 'undefined' && showLessTriggers != null) {
        for (var i = 0; i < showLessTriggers.length; i++) {
            showLessTriggers[i].addEventListener('click', function (event) {
                parent = this.parentElement.parentElement;
                parent.classList.add('list-cropped');
            });
        }
    }

    // Operator More & Show Less
    var showMoreOpTriggers = document.querySelectorAll('.op-meta-toggler.show-more');
    var showLessOpTriggers = document.querySelectorAll('.op-meta-toggler.show-less');

    if (typeof showMoreOpTriggers != 'undefined' && showMoreOpTriggers != null) {

        for (var i = 0; i < showMoreOpTriggers.length; i++) {
            showMoreOpTriggers[i].addEventListener('click', function (event) {
                parent = this.parentElement;

                if (parent.classList.contains('show-four')) {
                    parent.classList.remove('show-four');
                }
            });
        }
    }

    if (typeof showLessOpTriggers != 'undefined' && showLessOpTriggers != null) {
        for (var i = 0; i < showLessOpTriggers.length; i++) {
            showLessOpTriggers[i].addEventListener('click', function (event) {
                parent = this.parentElement;
                parent.classList.add('show-four');
            });
        }
    }

    var plus = document.getElementById('plus');
    var scrollToTop = document.getElementById('scrollToTop');

    function plusToggle() {
        plus.classList.toggle('plus--active');
    }
    function scrollTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    plus.addEventListener('click', plusToggle);
    scrollToTop.addEventListener('click', scrollTop);

})();

/*
    * Replace all SVG images with inline SVG
    */
function fixSvgs() {
    document.querySelectorAll('img.svg').forEach(function (img) {
        var imgID = img.id;
        var imgClass = img.className;
        var imgURL = img.src;

        fetch(imgURL).then(function (response) {
            return response.text();
        }).then(function (text) {

            var parser = new DOMParser();
            var xmlDoc = parser.parseFromString(text, "text/xml");

            // Get the SVG tag, ignore the rest
            var svg = xmlDoc.getElementsByTagName('svg')[0];

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                svg.setAttribute('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                svg.setAttribute('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            svg.removeAttribute('xmlns:a');

            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
            if (!svg.getAttribute('viewBox') && svg.getAttribute('height') && svg.getAttribute('width')) {
                svg.setAttribute('viewBox', '0 0 ' + svg.getAttribute('height') + ' ' + svg.getAttribute('width'))
            }

            // Replace image with new SVG
            img.parentNode.replaceChild(svg, img);

        });

    });

    // Get Cookie Function
    function getCookie(name) {
        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    }

    // Set Cookie Function
    function setCookie(name, value, days) {
        var d = new Date;
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    }
    var show_cookie_banner = getCookie('cookieConsentAccepted') || getCookie('cookieConsentDeclined');

    // Show Cookie Policy Logic
    if (show_cookie_banner) {
        document.getElementById('cookieBanner').remove();
    } else {
        document.getElementById('cookieBanner').style.setProperty('display', 'block', 'important');

        document.getElementById('acceptCookies').addEventListener('click', function (event) {
            event.preventDefault();
            setCookie('cookieConsentAccepted', 1, 30);
            document.getElementById('cookieBanner').remove();
            //Add Cookie Consent To GTM
            if (typeof window.dataLayer === 'undefined') {
                window.dataLayer = [];
            }
            window.dataLayer.push({
                'event': 'cookieConsentAccepted'
            });
            location.reload();
        });

        document.getElementById('acceptCookies').addEventListener('click', function (event) {
            e.preventDefault();
            setCookie('cookieConsentDeclined', 1, 30);
            document.getElementById('cookieBanner').remove();
        });
    }
}

// TOC Plugin
// https://github.com/vincentlaucsb/js-toc/blob/master/dist/toc.js
function snakeCase(text) {
    return text.toLowerCase().split(" ").join("_");

}
function scanHeaders(parent) {
    if (parent === void 0) { parent = document.body; }
    /*
     * Iterate through header tags in page
     * - Side effect: If header has no ID tag, generate one based by snake-casing
     *   the inner text
     *  - Otherwise, add ID to set of processed IDs
     *  - Also, if generated name collides with another one, append a number
     *
     * Return: An array of IDs
     *
     */

    var headers = parent.querySelectorAll("h1, h2, h3, h4, h5, h6");
    var processed = Object();
    var temp = new Array();
    for (var i = 0; i < headers.length; i++) {
        var h = headers[i];
        var processed_id = h.getAttribute("id");
        // No ID found
        if (!processed_id) {
            var snake_cased = snakeCase(h.innerText);
            if (snake_cased in processed) {
                processed_id = snake_cased + "_" + ++processed[snake_cased];
            }
            else {
                processed_id = snake_cased;
                processed[processed_id] = 1;
            }
            h.setAttribute("id", processed_id);
        }
        else {
            processed[processed_id] = 1;
        }
        temp.push({
            'level': parseInt(h.tagName[1]),
            'name': h.textContent,
            'id': processed_id
        });
    }
    return temp;
}
function makeListItem(href, text) {
    // Generate a bullet point containing a link
    var link = document.createElement('a');
    link.setAttribute('href', href);
    link.innerHTML = text;
    var temp = document.createElement('li');
    temp.appendChild(link);
    return temp;
}
function makeList(listParams) {
    if (listParams === void 0) {
        listParams = {
            'target': "",
            'parent': "body"
        };
    }
    var headers = scanHeaders(document.querySelector(listParams.parent));
    // Keep track of where we are in the list;
    var parents = [
        document.createElement("ul")
    ];
    var currentLevel = null; // Used to determine when to indent/dedent list
    var prevBullet = null;
    for (var i in headers) {
        var currentParent = parents.slice(-1)[0];
        var tocItem = headers[i];
        var link = makeListItem("#" + tocItem.id, tocItem.name);
        // Add link text
        if (currentLevel) {
            var levelDiff = tocItem.level - currentLevel;
            if (levelDiff <= 0) {
                // Dedent (or stay the same)
                while (parents.length > 1 && levelDiff) {
                    parents.pop();
                    levelDiff++;
                }
            }
            else if (levelDiff > 0) {
                // Indent
                while (levelDiff) {
                    var nextParent = document.createElement("ul");
                    prevBullet.appendChild(nextParent);
                    currentParent.appendChild(prevBullet);
                    currentParent = nextParent;
                    parents.push(nextParent);
                    levelDiff--;
                }
            }
            // Update parent
            currentParent = parents.slice(-1)[0];
        }
        // Update
        currentLevel = tocItem.level;
        currentParent.appendChild(link);
        prevBullet = link;
    }
    var target = document.querySelector(listParams.target);
    target.appendChild(parents[0]);
}
//# sourceMappingURL=toc.js.map
